import moment from 'moment';

import type { TagElementType } from '@/atoms/Tags/Tags';
import type { FeedItemType } from '@/types';

export const filterTags = (tags: TagElementType[]): TagElementType[] => {
  return tags.filter(({ value }) => value);
};

export const getFilterTags = (result: FeedItemType): TagElementType[] => {
  let tags: TagElementType[] = [];
  switch (result.category) {
    case 'regulators':
      tags = [
        { tagKey: 'Security code', value: result.security_code },
        { tagKey: 'Security id', value: result.security_id },
        { tagKey: 'CIK', value: result.cik?.toString() },
        { tagKey: 'ISIN', value: result.isin },
        ...(result.indices?.map(({ index_name }) => ({
          tagKey: 'Indices',
          value: index_name,
        })) ?? []),
        ...(result.secondary_category?.map((category) => ({
          tagKey: 'Category',
          value: category,
        })) ?? []),
        {
          tagKey: 'Report date',
          value: moment.unix(result.unix).format('DD-MM-YYYY'),
        },
      ];
      break;
    default:
      tags = [];
  }

  return tags;
};
